import * as React from "react";
import { Cpu } from "lucide-react";
import { ListViewCard } from "../ListViewCard";
import type { ListViewCardLayout } from "../ListViewCard";
import * as s from "../ListViewCard/ListViewCard.style.css";
import type { CardRenderContext } from "../../types";

export interface ListViewComponentCardComponent {
  id: string;
  componentType: string;
  name?: string | null;
  componentIndex?: number | null;
  serial?: string | null;
  model?: string | null;
  fwVersion?: string | null;
  hwVersion?: string | null;
  isActive?: boolean;
}

export interface ListViewComponentCardProps {
  layout: ListViewCardLayout;
  component: ListViewComponentCardComponent;
  ctx?: CardRenderContext;
  onClick?: () => void;
}

export function ListViewComponentCard({
  layout,
  component: comp,
  ctx,
  onClick,
}: ListViewComponentCardProps) {
  const compact = ctx?.compact ?? false;

  const imageClass =
    compact
      ? s.logoBoxCompact
      : layout === "deck"
      ? s.logoBoxDeck
      : s.logoBox;

  const iconSize = compact ? 20 : layout === "deck" ? 36 : 28;

  const image = (
    <div className={imageClass}>
      <Cpu size={iconSize} style={{ opacity: 0.55 }} />
    </div>
  );

  const titleLabel = comp.name
    ? comp.name
    : comp.componentIndex != null
    ? `${comp.componentType} #${comp.componentIndex}`
    : comp.componentType;

  const subtitleParts = [
    comp.serial ? `S/N: ${comp.serial}` : null,
    comp.model ? comp.model : null,
  ].filter(Boolean);
  const subtitle = subtitleParts.length > 0 ? subtitleParts.join(" · ") : undefined;

  const footerText = comp.fwVersion ? `FW: ${comp.fwVersion}` : undefined;

  const statusBadge = comp.isActive === false
    ? { id: "status", label: "Inactive", variant: "disabled" as const }
    : { id: "status", label: comp.componentType, variant: "default" as const };

  return (
    <ListViewCard
      id={comp.id}
      layout={layout}
      imageFormat="logo"
      image={image}
      title={titleLabel}
      subtitle={subtitle}
      badges={[statusBadge]}
      footerText={footerText}
      onClick={onClick ?? ctx?.onClick}
      compact={compact}
    />
  );
}
